// Fisher-Yates shuffle
export function shuffleMessages(
  list: string[],
  rng: () => number = Math.random,
): string[] {
  const copy = [...list]
  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng() * (i + 1))
    const temp = copy[i]
    copy[i] = copy[j]
    copy[j] = temp
  }

  return copy
}
